<template>
	<div class="deat_box">
		<div class="box_head p_b_b">
			<span class="type_size_22" v-html="data.title"></span>
			<div class="p_flex p_f_a p_f_b p_m_t_20">
				<div class="p_flex p_f_1 one-overflow p_m_r_30">{{data.enquire_date}}</div>
				<div class="p_flex type_size_16">
					<span class="subject_yellow" v-if="data.type == 1">
					{{data.subject_def}}
					<el-divider direction="vertical"></el-divider>
					</span>

					<span >{{data.student?data.student.name:''}}</span>
				</div>
			</div>
		</div>
		<div class="box_head">
			<span class="type_size_16 p_flex p_f_c" v-if="data.answer_date">{{data.answer_date}}</span>
			<div class="box_center p_m_t_20" v-if="data.type == 1">
				<span class="type_size_16">{{data.student?data.student.name:''}}：{{data.student_content}}</span>
			</div>
		</div>
		<div class="subject_color type_size_18" v-if="data.teacher_content">
			回答：{{data.teacher_content}}
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			data: {},
		}
	},
	mounted(){
		this.$request.ajax(this).post('api_student/put_question_detail/'+this.$route.query.id).then(res=>{
			console.log(res.data)
			this.data = res.data
		})
	},
	methods:{

	}
}
</script>

<style lang="scss" scoped>
.deat_box {
	padding: 0 260px;
}
.box_head {
	padding: 20px 0;
}
.box_center{
	background-color: #F5F5F5;
	padding: 30px;
	border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/news/commponents/errorDeatil.vue